import { COLORS } from '@/views/admin/dashboard/dashboardTheme.ts';
import React, { ReactNode } from 'react';

interface Props {
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  subtitle?: string;
  title: string;
}

export const DashboardCard: React.FC<Props> = ({
  actions,
  children,
  className = '',
  subtitle,
  title,
}) => (
  // borders are inline: Boosted's .border utility is !important, black and 2px wide
  <section className={`min-w-0 bg-white p-5 ${className}`} style={{ border: '1px solid #e5e5e5' }}>
    <header className="mb-4 flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <h2 className="m-0 text-lg font-bold leading-tight" style={{ color: COLORS.ink }}>
          {title}
        </h2>
        {subtitle && (
          <p className="m-0 mt-1 text-sm" style={{ color: COLORS.inkSecondary }}>
            {subtitle}
          </p>
        )}
      </div>
      {actions}
    </header>
    {children}
  </section>
);

interface SegmentedProps<T extends string> {
  ariaLabel: string;
  dark?: boolean;
  onChange: (value: T) => void;
  options: { label: string; value: T }[];
  value: T;
}

// A row of mutually exclusive buttons, e.g. the period or the map layer
export const Segmented = <T extends string>({
  ariaLabel,
  dark = false,
  onChange,
  options,
  value,
}: SegmentedProps<T>) => (
  <div aria-label={ariaLabel} className="inline-flex" role="group">
    {options.map(option => {
      const active = option.value === value;
      return (
        <button
          aria-pressed={active}
          className="cursor-pointer px-3 py-1.5 text-sm font-bold transition-colors"
          key={option.value}
          onClick={() => onChange(option.value)}
          style={{
            backgroundColor: active ? COLORS.orange : 'transparent',
            border: `1px solid ${active ? COLORS.orange : dark ? '#555' : '#ccc'}`,
            color: active ? COLORS.ink : dark ? '#fff' : COLORS.ink,
            marginLeft: -1,
          }}
          type="button"
        >
          {option.label}
        </button>
      );
    })}
  </div>
);
